import { FDA } from '@benzinga/calendar-manager';
import CalendarService from '../lib/services/CalendarService';
import { fetchTickersLogos } from '../lib/utils';

export const FDACalendarTabKeys: ('historical' | 'exact-dates' | 'estimated-dates' | 'pdufa')[] = [
  'historical',
  'exact-dates',
  'estimated-dates',
  'pdufa',
];

export type FDACalendarTabKeysType = (typeof FDACalendarTabKeys)[number];

const fetchFDA = async (params = {}, tabKey?: FDACalendarTabKeysType, pageSize = 1000): Promise<FDA[]> => {
  try {
    const query = {
      ...params,
      pagesize: pageSize,
      'parameters[date_sort_strict]': false,
    };

    if (tabKey === 'exact-dates' || tabKey === 'estimated-dates' || tabKey === 'pdufa') {
      query['parameters[date_search_field]'] = 'target';
      query['parameters[date_sort]'] = 'target';
    } else {
      query['parameters[date_search_field]'] = 'announced';
      query['parameters[date_sort]'] = 'announced';
    }

    const Calendar = new CalendarService();

    let items: FDA[] = [];
    const response = await Calendar.getFda(query);

    if (response.data) {
      items = response.data['fda'];
      return response.data['fda'];
    }

    let logos: any = null;
    const tickers: any[] = [];

    if (items.length > 0) {
      items.forEach(item => {
        if (item.companies && item.companies.length > 0) {
          item.companies.forEach((c: any) => {
            if (c.securities && c.securities.length > 0) {
              c.securities.forEach((s: any) => {
                tickers.push(s.symbol);
              });
            }
          });
        }
      });
      logos = await fetchTickersLogos(tickers);

      if (logos && Object.keys(logos).length > 0) {
        items.forEach(item => {
          if (item.companies && item.companies.length > 0) {
            item.companies.forEach((c: any) => {
              if (c.securities && c.securities.length > 0) {
                c.securities.forEach((s: any) => {
                  if (logos[s.symbol]) {
                    s['logo'] = logos[s.symbol];
                  }
                });
              }
            });
          }
        });
      }
    }

    return items;
  } catch (e) {
    return [];
  }
};

export { fetchFDA };
